namespace Matrix.Indexation {
    export interface FactIndexConstituentRorForm {
        IndexationProfileKey: Serenity.IntegerEditor;
        CompositeKey: Serenity.IntegerEditor;
        IndexKey: Serenity.IntegerEditor;
        BaseDate: Serenity.DateEditor;
        EffectiveDate: Serenity.DateEditor;
        SourceCode: Serenity.StringEditor;
        LocalReturn: Serenity.DecimalEditor;
        CurrencyReturn: Serenity.DecimalEditor;
        HedgedReturn: Serenity.DecimalEditor;
        UnhedgedReturn: Serenity.DecimalEditor;
        TotalReturn: Serenity.DecimalEditor;
        DefaultSortOrder: Serenity.IntegerEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class FactIndexConstituentRorForm extends Serenity.PrefixedContext {
        static formKey = 'Indexation.FactIndexConstituentRor';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FactIndexConstituentRorForm.init)  {
                FactIndexConstituentRorForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DateEditor;
                var w2 = s.StringEditor;
                var w3 = s.DecimalEditor;
                var w4 = StaticTextBlock;
                var w5 = ReadOnlyDateTime;

                Q.initFormType(FactIndexConstituentRorForm, [
                    'IndexationProfileKey', w0,
                    'CompositeKey', w0,
                    'IndexKey', w0,
                    'BaseDate', w1,
                    'EffectiveDate', w1,
                    'SourceCode', w2,
                    'LocalReturn', w3,
                    'CurrencyReturn', w3,
                    'HedgedReturn', w3,
                    'UnhedgedReturn', w3,
                    'TotalReturn', w3,
                    'DefaultSortOrder', w0,
                    'CreatedBy', w4,
                    'CreatedWhen', w5,
                    'UpdatedBy', w4,
                    'UpdatedWhen', w5,
                    'Version', w4
                ]);
            }
        }
    }
}
